export enum FoodCategory{
    BREAD = 'BREAD',
    CURRY = 'CURRY'
}